/*
 * 3D Kutu Harf Tasarla: adım adım tasarım sihirbazı.
 * Akış, katalog ve uyumluluk: kutu-harf-catalog.js · ölçü ve metrikler: kutu-harf-glyphs.js
 * Fiyat: kutu-harf-pricing.js (quote null iken fiyat alanları gizli) · 3D: kutu-harf-scene.js
 *
 * Adım geçişleri pushState ile (tarayıcının geri tuşu bir önceki adıma döner), diğer
 * değişiklikler replaceState ile adrese yazılır. Paylaşım linki özet ekranını açar.
 */

const root = document.querySelector('[data-kh]');
const config = JSON.parse(root.querySelector('[data-kh-config]').textContent);
const [C, G, P] = await Promise.all([import(config.catalog), import(config.glyphs), import(config.pricing)]);
const { CATALOG, PALETTES, FINISHES, FONTS, STEPS, byId, palette } = C;

const LABELS = {
  loading: 'Tabelanız hazırlanıyor…',
  noWebgl: 'Tarayıcınız 3D önizlemeyi desteklemiyor. Seçimlerinizi yine de WhatsApp’tan gönderebilirsiniz.',
  loadError: '3D önizleme yüklenemedi. Seçimlerinizi yine de WhatsApp’tan gönderebilirsiniz.',
  count: (i, n) => `Adım ${i} / ${n}`,
  continueColor: 'Bu renkle devam et',
  corporate: 'Kurumsal renginiz farklıysa mesajınızda belirtin.',
  acrylicLed: 'Işık pleksi renginde yanar',
  restart: 'Tekrar tasarla',
  backToText: 'Yazıya dön',
  missing: (list) => `Bu fontta ${list.map((c) => `‘${c}’`).join(', ')} karakteri yok; önizlemede gösterilmiyor.`,
  metrics: (m, depth) =>
    [`${m.count} harf`, `Genişlik ${C.fmt(m.width)} cm`, `Harf yüksekliği ${C.fmt(m.cap)} cm`, m.showTotal ? `Toplam yükseklik ${C.fmt(m.total)} cm` : null, depth ? `Derinlik ${depth} cm` : null]
      .filter(Boolean)
      .join(' · '),
  sampleMetrics: 'Ölçüler yazınızı girince hesaplanır.',
  waIntro: 'Merhaba, kutu harf tasarımım için fiyat almak istiyorum.',
  downloadFail: 'Görsel hazırlanamadı. Birkaç saniye sonra yeniden deneyin.',
};

const $ = (sel) => root.querySelector(sel);
const $$ = (sel) => [...root.querySelectorAll(sel)];
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const mqMobile = window.matchMedia('(max-width: 989px)');
const debug = new URLSearchParams(location.search).get('debug') === '1';

function el(tag, attrs = {}, children = []) {
  const n = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v === null || v === undefined || v === false) continue;
    if (k === 'class') n.className = v;
    else if (k === 'text') n.textContent = v;
    else if (k === 'style') n.style.cssText = v;
    else n.setAttribute(k, v === true ? '' : v);
  }
  for (const c of [].concat(children)) if (c !== null && c !== undefined && c !== false) n.append(c);
  return n;
}
const chars = (s) => Array.from(s);
const cleanText = (s) => chars(String(s || '').replace(/[\r\n\t]+/g, ' ')).slice(0, CATALOG.maxText).join('');

// ---------- Durum ----------

// Eski kurallarla oluşmuş linkler geçerli yola çekilir; açıklama özette gösterilir
const loadNotes = [];
let state = C.fromParams(new URLSearchParams(location.search), cleanText, loadNotes);
const ui = {
  mode: 'text', // text | letter (özetteki "harfi yakından incele")
  letter: null,
  metrics: null,
  notes: loadNotes,
  // Font varsayılan seçili gelir (Arimo); kullanıcı font adımını görüp seçene kadar adım tamamlanmış sayılmaz
  fontSeen: false,
  trailOpen: false,
};

// Kutu boşken 3D'de örnek yazı gösterilir; örnek yazı state'e, adrese, mesaja ve ölçülere girmez
const isSample = () => !cleanText(state.t).trim();
const displayText = () => cleanText(state.t).trim() || config.defaultText;
const steps = () => C.getSteps(state);
const lit = () => C.isLit(state);
// Görünüm: kullanıcı seçmediyse ışıklıda gece
const night = () => !isSample() && lit() && (state.on === null ? true : state.on);

// Önceki adımlardan biri eksikse oraya gidilir (elle yazılmış ya da yarım kalmış adres)
function clampStep(st) {
  const list = C.getSteps(st);
  if (st.step === 'ozet') return st;
  const idx = Math.max(0, list.indexOf(st.step));
  for (let i = 0; i < idx; i++) if (!C.stepDone(list[i], st)) return { ...st, step: list[i] };
  return list.includes(st.step) ? st : { ...st, step: 'yazi' };
}
state = clampStep(state);
// Font adımından ileride açılan adres (paylaşım linki, sayfa yenileme) fontu görülmüş sayar
ui.fontSeen = state.step === 'ozet' || steps().indexOf(state.step) > steps().indexOf('font');

// keepDebug: yalnızca adres çubuğu için (paylaşılan linke ?debug=1 karışmasın)
function shareURL(st = state, keepDebug = false) {
  const u = new URL(location.href);
  u.search = C.toParams(st).toString();
  if (debug && keepDebug) u.searchParams.set('debug', '1');
  u.hash = '';
  return u.toString();
}

// ---------- Adres ----------

let urlTimer = 0;
function writeURL(push) {
  clearTimeout(urlTimer);
  try {
    const url = shareURL(state, true);
    // kh: sihirbaz içindeki geçmiş derinliği (Geri butonu sayfadan çıkmasın)
    if (push) history.pushState({ kh: ((history.state && history.state.kh) || 1) + 1 }, '', url);
    else if (url !== location.href) history.replaceState(history.state, '', url);
  } catch (e) {
    /* önizleme çerçevesinde engellenebilir */
  }
  writeLinks();
}
const queueURL = () => {
  clearTimeout(urlTimer);
  urlTimer = setTimeout(() => writeURL(false), 250);
};

window.addEventListener('popstate', () => {
  state = clampStep(C.fromParams(new URLSearchParams(location.search), cleanText));
  ui.mode = 'text';
  render({ focus: true });
  syncScene();
});

// ---------- Değişiklik ----------

// pinned: kullanıcının değiştirdiği alan (özetteki uyumsuz değişiklikler diğer alanları çeker)
function update(patch, { pinned = null, geometry = false } = {}) {
  const r = C.resolveCompatible({ ...state, ...patch }, pinned);
  state = r.state;
  ui.notes = r.notes;
  render();
  syncScene(geometry);
  queueURL();
}

function go(step, { push = true, focus = true } = {}) {
  state = { ...state, step };
  ui.mode = 'text';
  writeURL(push);
  render({ focus });
  syncScene();
}

// Adım tamam mı (font, görülene kadar tamam sayılmaz)
const done = (step) => C.stepDone(step, state) && (step !== 'font' || ui.fontSeen);

function next() {
  const list = steps();
  const i = list.indexOf(state.step);
  // İleride tamamlanmamış ilk adıma, hepsi tamamsa özete
  for (let j = i + 1; j < list.length; j++) if (!done(list[j])) return go(list[j]);
  go('ozet');
}

function choose(key, value) {
  if (key === 'f') ui.fontSeen = true;
  const patch = { [key]: value };
  // Tek ürünlü ışık tipinden (Sadece Yandan → Pleksi) çıkınca ürün yeniden sorulsun
  if ((key === 'lt' || key === 'ltype') && state.p && C.autoProduct(state) === state.p) patch.p = null;
  update(patch);
  next();
}

// Kendiliğinden geçilen adım (tek ürünlü ışık tipinde ürün): geri giderken de atlanır
const autoStep = (step) => step === 'urun' && !!C.autoProduct(state);

// ---------- Ortak bileşenler ----------

const photo = (k) => (config.photos && config.photos[k]) || null;

// Kart: görsel üstte, ad altta, altında (fiyat motoru gelince) fiyat satırı.
// Görsel: section'da fotoğraf seçildiyse fotoğraf, yoksa canlı 3D'den anlık görüntü (shot).
function card({ set, value, title, desc, img, shot, selected, extraClass = '', fallback = null }) {
  const media = el('span', { class: 'kh__card-media' });
  if (img) media.append(el('img', { class: 'kh__card-img', src: img, alt: '', loading: 'lazy', width: 640, height: 400 }));
  else {
    media.append(el('span', { class: 'kh__card-skel', 'aria-hidden': 'true' }));
    if (fallback) media.append(fallback);
    if (shot) Shots.attach(media, shot);
  }
  return el('button', { type: 'button', class: `kh__card ${extraClass}`, 'data-set': set, 'data-value': value, 'aria-pressed': String(!!selected) }, [
    media,
    el('span', { class: 'kh__card-body' }, [
      el('span', { class: 'kh__card-title', text: title }),
      desc ? el('span', { class: 'kh__card-desc', text: desc }) : null,
      el('span', { class: 'kh__card-price', 'data-kh-price-line': `${set}:${value}`, hidden: true }),
    ]),
  ]);
}

function swatches(set, list, current, { compact = false, labelledby = null } = {}) {
  return el(
    'div',
    { class: `kh__swatches${compact ? ' kh__swatches--compact' : ''}`, role: 'group', 'aria-labelledby': labelledby },
    list.map((c) =>
      el('button', { type: 'button', class: 'kh__sw', 'data-set': set, 'data-value': c.id, 'aria-pressed': String(c.id === current), 'aria-label': c.ral ? `${c.name}, RAL ${c.ral}` : c.name, title: compact ? c.name : null }, [
        el('span', { class: 'kh__sw-dot', style: `--kh-sw:${c.hex}` }),
        compact ? null : el('span', { class: 'kh__sw-name', text: c.name }),
        compact || !c.ral ? null : el('span', { class: 'kh__sw-ral', text: `RAL ${c.ral}` }),
      ])
    )
  );
}

function seg(set, items, current, label) {
  return el(
    'div',
    { class: 'kh__seg', role: 'group', 'aria-label': label },
    items.map(([id, name]) => el('button', { type: 'button', class: 'kh__seg-btn', 'data-set': set, 'data-value': id, 'aria-pressed': String(id === current) }, name))
  );
}

function stepHead(step) {
  const list = steps();
  return [
    el('p', { class: 'kh__count', text: LABELS.count(list.indexOf(step) + 1, list.length) }),
    el('h2', { class: 'kh__q', id: `kh-q-${step}`, tabindex: '-1', text: STEPS[step].title }),
  ];
}

// ---------- Kart görselleri ----------
// Ana renderer sırayla kullanılır: kare başına en fazla bir görsel, kullanıcı sahneyi
// döndürürken ya da yazı yeniden üretilirken üretim durur. Önbellek anahtarı görsel tarifinin
// kendisidir (yazı, font, ölçü, görünüm); kullanılmayan Object URL'ler sınır aşılınca bırakılır.

const SHOT_SIZE = { card: [400, 250], wide: [480, 270] };
const AB = { text: 'Ab', cm: 20 }; // ürün ve alt tip kartlarındaki örnek

const Shots = {
  cache: new Map(), // anahtar → objectURL (LRU)
  queue: [],
  pending: new Map(), // anahtar → kuyruk kaydı
  running: false,
  observer: null,
  max: 48,

  // shot: { spec, size: 'card' | 'wide', lazy }
  attach(media, { spec, size = 'card', lazy = false }) {
    const key = JSON.stringify([spec, size, spec.geometry ? null : mainKey()]);
    media.dataset.khShot = key;
    media._khShot = { key, spec, size };
    const url = this.cache.get(key);
    if (url) {
      this.cache.delete(key);
      this.cache.set(key, url);
      return this.fill(media, url);
    }
    if (lazy && 'IntersectionObserver' in window) {
      // Ekranda görünen kartlar önce, diğerleri göründükçe
      this.observer ||= new IntersectionObserver(
        (entries) => {
          for (const e of entries) {
            if (!e.isIntersecting) continue;
            this.observer.unobserve(e.target);
            this.enqueue(e.target);
          }
        },
        { rootMargin: '120px' }
      );
      this.observer.observe(media);
    } else this.enqueue(media);
  },
  enqueue(media) {
    const { key, spec, size } = media._khShot;
    let job = this.pending.get(key);
    if (!job) {
      job = { key, spec, size: SHOT_SIZE[size], nodes: new Set() };
      this.pending.set(key, job);
      this.queue.push(job);
    }
    job.nodes.add(media);
    this.pump();
  },
  fill(media, url) {
    media.replaceChildren(el('img', { class: 'kh__card-img', src: url, alt: '', width: 400, height: 250, decoding: 'async' }));
    media.classList.add('has-shot');
  },
  async pump() {
    if (this.running || !scene) return;
    this.running = true;
    try {
      await this.drain();
    } finally {
      this.running = false;
    }
  },
  async drain() {
    // Ön derleme bitmeden başlanmaz (aynı anda iki iş GPU'yu ve ana thread'i boğmasın)
    await scene.ready();
    while (this.queue.length) {
      await new Promise((r) => ('requestIdleCallback' in window ? requestIdleCallback(r, { timeout: 800 }) : setTimeout(r, 60)));
      await new Promise((r) => requestAnimationFrame(r));
      // Kullanıcı döndürürken ya da yazı yeniden üretilirken beklenir
      if (scene.isBusy() || geoPending) {
        await new Promise((r) => setTimeout(r, 250));
        continue;
      }
      const job = this.queue.shift();
      this.pending.delete(job.key);
      const live = [...job.nodes].filter((n) => n.isConnected && n.dataset.khShot === job.key);
      if (!live.length) continue;
      let blob = null;
      try {
        blob = await scene.capture(job.spec, { width: job.size[0], height: job.size[1] });
      } catch (e) {
        console.warn('[kutu-harf]', e);
      }
      if (!blob) continue;
      const url = URL.createObjectURL(blob);
      this.cache.set(job.key, url);
      for (const n of live) if (n.dataset.khShot === job.key) this.fill(n, url);
      this.trim();
    }
  },
  trim() {
    if (this.cache.size <= this.max) return;
    const inUse = new Set($$('[data-kh-shot]').map((n) => n.dataset.khShot));
    for (const [k, url] of this.cache) {
      if (this.cache.size <= this.max) break;
      if (inUse.has(k)) continue;
      URL.revokeObjectURL(url);
      this.cache.delete(k);
    }
  },
};

// Kart görsel tarifleri: görünüm katalogdaki resolveLook ile, seçenek uygulanmış durumdan.
// geometry verilmezse ana yazı kullanılır (anahtara ana yazının ölçüsü eklenir).
const lookWith = (patch) => C.resolveLook({ ...state, ...patch });
const mainKey = () => JSON.stringify(geometryParams());
// Işıklı dalda ön yüz çoğu zaman opal pleksi: gündüz beyaz yüz duvara karışır, kartlar gece görünümünde
const cardNight = () => C.isLit(state);
function abGeo(patch) {
  const st = C.previewState({ ...state, ...patch });
  return { text: AB.text, font: st.f, cm: AB.cm, depth: C.depthOf(st) };
}

// ---------- Adımlar ----------

const BUILD = {
  isik() {
    return el('div', { class: 'kh__cards kh__cards--two' }, [
      card({ set: 'lt', value: 'isikli', title: 'Işıklı', desc: 'Gece de okunur; LED ile içten ya da arkadan aydınlatılır.', selected: state.lt === 'isikli', shot: { spec: { look: lookWith({ lt: 'isikli' }), night: true, view: 'main' }, size: 'wide' } }),
      card({ set: 'lt', value: 'isiksiz', title: 'Işıksız', desc: 'Gün ışığında ve dış aydınlatmayla görünür.', selected: state.lt === 'isiksiz', shot: { spec: { look: lookWith({ lt: 'isiksiz' }), night: false, view: 'main' }, size: 'wide' } }),
    ]);
  },
  'isik-tipi'() {
    return el(
      'div',
      { class: 'kh__cards' },
      Object.entries(CATALOG.lightTypes).map(([id, t]) =>
        card({ set: 'ltype', value: id, title: t.label, desc: t.desc, img: photo(`lt_${id}`), selected: state.ltype === id, shot: { spec: { look: lookWith({ lt: 'isikli', ltype: id }), night: true, view: 'main' } } })
      )
    );
  },
  font() {
    const st = C.previewState(state);
    const text = displayText();
    const look = C.resolveLook(state);
    return el(
      'div',
      { class: 'kh__cards' },
      FONTS.map((f) =>
        card({
          set: 'f',
          value: f.id,
          title: f.name,
          selected: state.f === f.id,
          extraClass: 'kh__card--font',
          // 3D açılamazsa yazı bu fontla düz metin olarak gösterilir
          fallback: el('span', { class: 'kh__font-sample', style: `font-family:'${f.family}',var(--font-body-family)`, text }),
          shot: { spec: { look, night: cardNight(), view: 'front', geometry: { text, font: f.id, cm: st.cm, depth: C.depthOf(st) } }, lazy: true },
        })
      )
    );
  },
  urun() {
    return el(
      'div',
      { class: 'kh__cards' },
      C.productsFor(state).map((id) => {
        const patch = { p: id, sub: null, pc: CATALOG.products[id].cardColor || null, ac: null, fin: null };
        return card({ set: 'p', value: id, title: CATALOG.products[id].label, img: photo(`p_${id}`), selected: state.p === id, shot: { spec: { look: lookWith(patch), night: cardNight(), view: 'threeQuarter', geometry: abGeo(patch) } } });
      })
    );
  },
  'alt-tip'() {
    const subs = CATALOG.products.strafor.subtypes;
    return el(
      'div',
      { class: 'kh__cards kh__cards--two' },
      Object.entries(subs).map(([id, s]) => {
        const patch = { p: 'strafor', sub: id, pc: s.cardColor || null };
        return card({ set: 'sub', value: id, title: s.label, img: photo(`sub_${id}`), selected: state.sub === id, shot: { spec: { look: lookWith(patch), night: false, view: 'threeQuarter', geometry: abGeo(patch) }, size: 'wide' } });
      })
    );
  },
  renk() {
    const p = C.product(state);
    const nodes = [];
    for (const f of C.colorFields(state)) {
      const list = palette(f.palette);
      const cur = state[f.key];
      nodes.push(
        el('div', { class: 'kh__field' }, [
          el('p', { class: 'kh__label', id: `kh-c-${f.key}`, text: f.label }),
          swatches(f.key, list, cur, { labelledby: `kh-c-${f.key}` }),
          f.palette === 'paintColors' ? el('p', { class: 'kh__note', text: LABELS.corporate }) : null,
        ])
      );
    }
    if (p && p.finishes) {
      const finish = seg('fin', p.finishes.map((id) => [id, FINISHES[id].label]), state.fin, 'Yüzey');
      finish.removeAttribute('aria-label');
      finish.setAttribute('aria-labelledby', 'kh-c-fin');
      nodes.push(el('div', { class: 'kh__field' }, [el('p', { class: 'kh__label', id: 'kh-c-fin', text: 'Yüzey' }), finish]));
    }
    nodes.push(el('button', { type: 'button', class: 'kh__primary', 'data-kh-next': '', disabled: !C.stepDone('renk', state) }, LABELS.continueColor));
    return el('div', { class: 'kh__colors' }, nodes);
  },
  led() {
    return el(
      'div',
      { class: 'kh__cards' },
      PALETTES.ledColors.map((c) => card({ set: 'led', value: c.id, title: c.name, selected: state.led === c.id, shot: { spec: { look: lookWith({ led: c.id }), night: true, view: 'main' } } }))
    );
  },
};

// Renk adımında seçim yalnızca önizlemeyi değiştirir; ileri geçiş butonla
const STAY = new Set(['pc', 'ac', 'fin']);

function renderStep(focus) {
  const step = state.step;
  const dyn = $('[data-kh-dynamic]');
  const textPanel = $('[data-kh-panel="yazi"]');
  textPanel.hidden = step !== 'yazi';
  if (step === 'yazi') {
    dyn.replaceChildren();
    textPanel.querySelector('[data-kh-count]').textContent = LABELS.count(1, steps().length);
    renderTextStep();
  } else if (step !== 'ozet') {
    // Adım içeriği yalnızca adım ya da seçenek yapısı değişince yeniden kurulur; aksi halde
    // yalnızca seçili durum güncellenir (sayfadaki analitik betiği her DOM eklemesini tarıyor)
    const key = stepKey(step);
    if (dyn.dataset.khKey !== key) {
      dyn.dataset.khKey = key;
      const panel = el('section', { class: 'kh__step', 'data-kh-panel': step, 'aria-labelledby': `kh-q-${step}` }, [...stepHead(step), BUILD[step]()]);
      dyn.replaceChildren(panel);
    } else {
      for (const b of dyn.querySelectorAll('button[data-set]')) setPressed(b, String(state[b.dataset.set]) === b.dataset.value);
      const nx = dyn.querySelector('[data-kh-next]');
      if (nx) nx.disabled = !C.stepDone(step, state);
    }
  } else {
    dyn.replaceChildren();
    dyn.dataset.khKey = '';
  }
  if (focus) focusHeading();
}

function setPressed(b, v) {
  const s = String(v);
  if (b.getAttribute('aria-pressed') !== s) b.setAttribute('aria-pressed', s);
}

// Adımın seçenek yapısını belirleyen alanlar; görsel tarifleri de buna bağlı
function stepKey(step) {
  const base = [step, steps().length];
  if (step === 'renk') return JSON.stringify([...base, state.p, state.sub, state.lt, state.ltype, C.colorFields(state).map((f) => f.key + f.palette)]);
  return JSON.stringify([...base, state.lt, state.ltype, state.f, state.p, state.sub, state.pc, state.ac, state.fin, state.led, geometryParams()]);
}

// Başlığa odak; sayfa adım kartına (ilerleme şeridinin hemen altı) kayar, yapışkan site üst bilgisi düşülür
function focusHeading() {
  const summary = state.step === 'ozet';
  const h = summary ? $('#kh-q-ozet') : $(`#kh-q-${state.step}`);
  if (!h) return;
  h.focus({ preventScroll: true });
  const header = document.querySelector('.section-header');
  const offset = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
  const target = summary ? $('[data-kh-picks]') : h.closest('.kh__step') || h;
  const top = target.getBoundingClientRect().top + window.scrollY - offset - 16;
  if (Math.abs(top - window.scrollY) > 8) window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion ? 'auto' : 'smooth' });
}

// Adım 1
function renderTextStep() {
  const input = $('[data-kh-text]');
  if (document.activeElement !== input && input.value !== state.t) input.value = state.t;
  $('[data-kh-text-n]').textContent = `${chars(state.t).length} / ${CATALOG.maxText}`;
  $('[data-kh-start]').disabled = !String(state.t).trim();
  const box = $('[data-kh-heights]');
  if (!box.childElementCount) {
    box.append(...CATALOG.heights.map((h) => el('button', { type: 'button', class: 'kh__height', 'data-set': 'cm', 'data-value': h, 'aria-pressed': 'false' }, [el('span', { class: 'kh__height-n', text: h }), ' cm'])));
  }
  for (const b of box.children) b.setAttribute('aria-pressed', String(+b.dataset.value === state.cm));
}

// ---------- İlerleme şeridi ----------

function trailText(step) {
  const st = state;
  switch (step) {
    case 'yazi': return `Yazı: ${cleanText(st.t).trim()} · ${st.cm} cm`;
    case 'isik': return CATALOG.lighting[st.lt].label;
    case 'isik-tipi': return CATALOG.lightTypes[st.ltype].label;
    case 'font': return `Font: ${byId(FONTS, st.f).name}`;
    case 'urun': return C.product(st).label;
    case 'alt-tip': return C.subtype(st).label;
    case 'renk': {
      const names = C.colorFields(st).map((f) => byId(palette(f.palette), st[f.key])?.name).filter(Boolean);
      return `Renk: ${names.join(' + ')}${st.fin ? `, ${FINISHES[st.fin].label}` : ''}`;
    }
    case 'led': return `LED: ${byId(PALETTES.ledColors, st.led).name}`;
    default: return STEPS[step].short;
  }
}

function renderTrail() {
  const list = steps();
  const cur = list.indexOf(state.step);
  const items = [];
  list.forEach((step, i) => {
    if (step === 'ozet') return;
    const isDone = done(step);
    if (step === state.step) items.push(el('li', { class: 'kh__trail-item is-current', 'aria-current': 'step' }, el('span', { text: STEPS[step].short })));
    else if (isDone && (i < cur || state.step === 'ozet' || i <= list.findIndex((s) => !done(s)))) {
      items.push(el('li', { class: 'kh__trail-item' }, el('button', { type: 'button', 'data-kh-goto': step, text: trailText(step) })));
    }
    // LED adımı olmayan ışıklı yollarda ışık pleksi renginden gelir; şeride not düşülür
    if (step === 'renk' && isDone && state.p && (i < cur || state.step === 'ozet') && lit() && !C.needsLed(state)) items.push(el('li', { class: 'kh__trail-item kh__trail-item--note' }, el('span', { text: LABELS.acrylicLed })));
  });
  if (state.step === 'ozet') items.push(el('li', { class: 'kh__trail-item is-current', 'aria-current': 'step' }, el('span', { text: STEPS.ozet.short })));
  $('[data-kh-trail-list]').replaceChildren(...items);
  $('[data-kh-back]').hidden = cur <= 0;
  $('[data-kh-trail-toggle]').querySelector('[data-kh-trail-count]').textContent = `${cur + 1}/${list.length} · ${STEPS[state.step].short}`;
  $('[data-kh-trail]').classList.toggle('is-open', ui.trailOpen);
  $('[data-kh-trail-toggle]').setAttribute('aria-expanded', String(ui.trailOpen));
}

// ---------- Özet ----------

let picksKey = '';
let pickId = 0;
function pickCard(title, body, extra) {
  const id = `kh-pick-${++pickId}`;
  const parts = [].concat(body);
  // Görünür başlık karttaki ilk denetimin etiketi; ikinci denetim (alt tip, yükseklik) kendi adını taşır
  const first = parts[0];
  if (first && first.nodeType === 1 && first.matches('select, input, [role="group"]')) {
    first.removeAttribute('aria-label');
    first.setAttribute('aria-labelledby', id);
  }
  return el('div', { class: 'kh__pick' }, [el('p', { class: 'kh__pick-title', id, text: title }), ...parts, extra || null]);
}
function select(set, options, current, label) {
  return el(
    'select',
    { class: 'kh__select', 'data-set': set, 'aria-label': label },
    options.map(([v, name]) => el('option', { value: v, selected: v === current ? true : null }, name))
  );
}

function renderPicks() {
  const st = state;
  const p = C.product(st);
  const fields = C.colorFields(st);
  const key = [st.p, st.sub, st.lt, st.ltype, fields.map((f) => f.key + f.palette).join(','), C.needsLed(st)].join('|');
  const box = $('[data-kh-pick-list]');
  if (key !== picksKey) {
    picksKey = key;
    const nodes = [];
    const prodOpts = Object.entries(CATALOG.products).map(([id, x]) => [id, x.label]);
    nodes.push(
      pickCard('Ürün tipi', [
        select('p', prodOpts, st.p, 'Ürün tipi'),
        p.subtypes ? select('sub', Object.entries(p.subtypes).map(([id, x]) => [id, x.label]), st.sub, 'Strafor tipi') : null,
      ].filter(Boolean))
    );
    nodes.push(pickCard('Işık', select('lt', Object.entries(CATALOG.lighting).map(([id, x]) => [id, x.label]), st.lt, 'Işıklı ya da ışıksız')));
    if (lit()) nodes.push(pickCard('Işık tipi', select('ltype', Object.entries(CATALOG.lightTypes).map(([id, x]) => [id, x.label]), st.ltype, 'Işık tipi')));
    nodes.push(
      pickCard('Yazı ve yükseklik', [
        el('input', { type: 'text', class: 'kh__pick-input', maxlength: CATALOG.maxText, value: st.t, 'aria-label': 'Tabela metni', 'data-kh-sum-text': '', autocomplete: 'off', spellcheck: 'false' }),
        select('cm', CATALOG.heights.map((h) => [String(h), `${h} cm`]), String(st.cm), 'Harf yüksekliği'),
      ])
    );
    nodes.push(pickCard('Font', select('f', FONTS.map((f) => [f.id, f.name]), st.f, 'Font')));
    for (const f of fields) nodes.push(pickCard(f.label, swatches(f.key, palette(f.palette), st[f.key], { compact: true }), el('p', { class: 'kh__pick-value', 'data-kh-pick-value': f.key })));
    if (p.finishes) nodes.push(pickCard('Yüzey', seg('fin', p.finishes.map((id) => [id, FINISHES[id].label]), st.fin, 'Yüzey')));
    if (C.needsLed(st)) nodes.push(pickCard('LED rengi', swatches('led', PALETTES.ledColors, st.led, { compact: true }), el('p', { class: 'kh__pick-value', 'data-kh-pick-value': 'led' })));
    else if (lit()) nodes.push(pickCard('LED rengi', el('p', { class: 'kh__pick-value', text: LABELS.acrylicLed })));
    nodes.push(el('button', { type: 'button', class: 'kh__restart', 'data-kh-restart': '' }, LABELS.restart));
    box.replaceChildren(...nodes);
  }
  // Değerler yerinde güncellenir
  for (const s of box.querySelectorAll('select[data-set]')) {
    const v = String(st[s.dataset.set] ?? '');
    if (s.value !== v) s.value = v;
  }
  for (const b of box.querySelectorAll('button[data-set]')) b.setAttribute('aria-pressed', String(String(st[b.dataset.set]) === b.dataset.value));
  for (const v of box.querySelectorAll('[data-kh-pick-value]')) {
    const k = v.dataset.khPickValue;
    const f = fields.find((x) => x.key === k);
    const c = byId(palette(f ? f.palette : 'ledColors'), st[k]);
    v.textContent = c ? (c.ral ? `${c.name} · RAL ${c.ral}` : c.name) : '';
  }
  const t = box.querySelector('[data-kh-sum-text]');
  if (t && document.activeElement !== t && t.value !== st.t) t.value = st.t;

  const fix = $('[data-kh-fix]');
  fix.hidden = !ui.notes.length;
  fix.textContent = ui.notes.join(' ');
}

// Canlıda yalnızca teyitli maddeler; ?debug=1 taslakları işaretli gösterir. Madde yoksa bölüm gizli.
function renderSpecs() {
  const list = C.specsFor(state).filter((x) => debug || !x.draft);
  $('[data-kh-specs-section]').hidden = !list.length;
  const name = $('[data-kh-specs-name]');
  if (name) name.textContent = C.fullName(state);
  $('[data-kh-specs]').replaceChildren(...list.map((x) => el('li', { class: x.draft ? 'kh__spec--draft' : null, text: x.draft ? `${x.text} (taslak)` : x.text })));
}

function renderPrice() {
  const q = P.quote(state, ui.metrics);
  $('[data-kh-price-empty]').hidden = !!q;
  const table = $('[data-kh-price-table]');
  table.hidden = !q;
  if (q) {
    table.tBodies[0].replaceChildren(...q.lines.map((l) => el('tr', {}, [el('td', { text: l.char }), el('td', { text: `${l.height} cm` }), el('td', { text: P.formatPrice(l.price, q.currency) })])));
    $('[data-kh-price-total]').textContent = P.formatPrice(q.total, q.currency);
  }
  // Kartlardaki fiyat satırları
  for (const n of $$('[data-kh-price-line]')) {
    const [k, v] = n.dataset.khPriceLine.split(':');
    const d = q && q.options && q.options[k] && q.options[k][v];
    n.hidden = d === undefined || d === null;
    n.textContent = n.hidden ? '' : d >= 0 ? `+${P.formatPrice(d, q.currency)}` : P.formatPrice(d, q.currency);
  }
  const dbg = $('[data-kh-debug]');
  dbg.hidden = !debug || !ui.metrics;
  if (debug && ui.metrics) {
    const m = ui.metrics;
    const row = (c) => el('tr', {}, [c.char, c.height, c.top, c.bottom, c.bboxWidth, c.bboxHeight, c.faceArea, c.perimeter].map((v, i) => el('td', { text: i === 0 ? v : C.fmt(v) })));
    dbg.replaceChildren(
      el('table', { class: 'kh__debug-table' }, [
        el('caption', {
          text: `Karakter metrikleri (cm, cm²) · büyük harf ${C.fmt(m.cap)} · en uzun harf ${C.fmt(m.tallest)} · küçük harf ${m.xHeight ? C.fmt(m.xHeight) : '-'} (font metriği) · toplam ${C.fmt(m.total)} · genişlik ${C.fmt(m.width)}`,
        }),
        el('thead', {}, el('tr', {}, ['Karakter', 'Büyük harf', 'Üst', 'Alt', 'En', 'Boy', 'Ön yüz alanı', 'Çevre'].map((h) => el('th', { scope: 'col', text: h })))),
        el('tbody', {}, ui.metrics.chars.map(row)),
      ])
    );
  }
}

// ---------- Ölçü (adım 2) ve metrik satırı ----------

const fontJSON = new Map();
function loadFontJSON(id) {
  if (!fontJSON.has(id)) {
    const p = fetch(config.fonts[id]).then((r) => (r.ok ? r.json() : Promise.reject(new Error(id))));
    p.catch(() => fontJSON.delete(id));
    fontJSON.set(id, p);
  }
  return fontJSON.get(id);
}

let metricsToken = 0;
async function updateMetrics() {
  const st = C.previewState(state);
  const token = ++metricsToken;
  if (isSample()) {
    ui.metrics = null;
    renderMetrics();
    if (state.step === 'isik') drawMeasure();
    renderPrice();
    writeLinks();
    return;
  }
  try {
    const font = await loadFontJSON(st.f);
    if (token !== metricsToken) return;
    ui.metrics = G.measure(font, displayText(), st.cm);
    renderMetrics();
    if (state.step === 'isik') drawMeasure();
    renderPrice();
    writeLinks();
  } catch (e) {
    console.warn('[kutu-harf]', e);
  }
}

function renderMetrics() {
  const m = ui.metrics;
  const line = $('[data-kh-metrics]');
  if (isSample()) return void (line.textContent = LABELS.sampleMetrics);
  if (!m) return void (line.textContent = '');
  // Derinlik teyit edilene kadar yalnızca ?debug=1 ile
  const parts = [LABELS.metrics(m, CATALOG.depthConfirmed || debug ? C.depthOf(state) : null)];
  if (m.missing.length) parts.push(LABELS.missing(m.missing));
  line.textContent = parts.join(' ');
}

// Yazının 2D çizimi ve ölçü çizgileri (cm). Yazı sağ tarafta yükseklik, altta genişlik ölçüsü alır.
const NS = 'http://www.w3.org/2000/svg';
const svgEl = (tag, attrs) => {
  const n = document.createElementNS(NS, tag);
  for (const [k, v] of Object.entries(attrs)) if (v !== null && v !== undefined) n.setAttribute(k, v);
  return n;
};
function drawMeasure() {
  const m = ui.metrics;
  const svg = $('[data-kh-measure-svg]');
  if (isSample()) {
    svg.replaceChildren();
    const cap = $('[data-kh-measure-cap]');
    cap.dataset.khKey = '';
    cap.textContent = LABELS.sampleMetrics;
    return;
  }
  if (!m || !svg.clientWidth) return;
  const { x0, y0, x1, y1 } = m.bbox;
  const W = x1 - x0;
  const H = y1 - y0;
  // Etiket boyu ekranda ~13px olsun. viewBox genişliği etiketlere bağlı olduğundan
  // vbW = A + fs·B ve fs = 13·vbW/ekranGenişliği denklemi çözülür.
  // Dar ekranda ya da ikiden çok ölçüde çizgilerde yalnızca kısa harf (H, U, x, T) yazar; değerler altta listelenir.
  // Her ölçü: [etiket, ad, değer, üst y, alt y, kılavuz çizgisi]
  const bottom = Math.min(0, y0);
  const dims = [['H', 'Harf yüksekliği (büyük harf)', m.cap, -m.cap, 0, true]];
  if (m.showTallest) dims.push(['U', 'En uzun harf', m.tallest, -m.tallest, 0, true]);
  if (m.xHeight) dims.push(['x', 'Küçük harf yüksekliği', m.xHeight, -m.xHeight, 0, true]);
  if (m.showTotal) dims.push(['T', 'Toplam yükseklik', m.total, -m.tallest, -bottom, false]);
  // Üçten fazla ölçüde değerler çizgi yanında yazı küçültür: yalnızca kısa harf, değerler listede
  const compact = svg.clientWidth < 440 || dims.length > 2;
  const labels = dims.map(([tag, , v]) => (compact ? tag : `${C.fmt(v)} cm`));
  const pad = Math.max(W, H) * 0.03;
  const laneEm = labels.map((l) => l.length * 0.62 + 2.4);
  const B = 1.2 + laneEm.reduce((x, y) => x + y, 0);
  const A = W + pad * 2;
  const px = 13 / svg.clientWidth;
  const vbW = A / Math.max(0.45, 1 - px * B);
  const fs = Math.min(px * vbW, (vbW - A) / B);
  const gap = fs * 1.2;
  const vx = x0 - pad;
  const vy = -y1 - pad;
  const vw = vbW;
  const vh = H + pad * 2 + gap + fs * 3;
  svg.setAttribute('viewBox', `${vx} ${vy} ${vw} ${vh}`);
  svg.setAttribute('preserveAspectRatio', 'xMinYMid meet');
  const g = [];
  g.push(svgEl('path', { d: m.path, class: 'kh__m-glyph' }));
  // Taban çizgisi
  g.push(svgEl('line', { x1: x0 - pad, y1: 0, x2: x1 + gap, y2: 0, class: 'kh__m-guide' }));
  const tick = fs * 0.5;
  const dimV = (x, ya, yb, label) => {
    g.push(svgEl('line', { x1: x, y1: ya, x2: x, y2: yb, class: 'kh__m-dim' }));
    g.push(svgEl('line', { x1: x - tick, y1: ya, x2: x + tick, y2: ya, class: 'kh__m-dim' }));
    g.push(svgEl('line', { x1: x - tick, y1: yb, x2: x + tick, y2: yb, class: 'kh__m-dim' }));
    const t = svgEl('text', { x: x + tick * 1.6, y: (ya + yb) / 2, 'font-size': fs, class: 'kh__m-label', 'dominant-baseline': 'middle' });
    t.textContent = label;
    g.push(t);
  };
  let lx = x1 + gap;
  dims.forEach(([, , , ya, yb, guide], i) => {
    if (i) lx += laneEm[i - 1] * fs;
    dimV(lx, ya, yb, labels[i]);
    if (guide) g.push(svgEl('line', { x1: x0 - pad, y1: ya, x2: lx, y2: ya, class: 'kh__m-guide' }));
  });
  const by = -y0 + gap;
  g.push(svgEl('line', { x1: x0, y1: by, x2: x1, y2: by, class: 'kh__m-dim' }));
  g.push(svgEl('line', { x1: x0, y1: by - tick, x2: x0, y2: by + tick, class: 'kh__m-dim' }));
  g.push(svgEl('line', { x1: x1, y1: by - tick, x2: x1, y2: by + tick, class: 'kh__m-dim' }));
  const t = svgEl('text', { x: (x0 + x1) / 2, y: by + fs * 1.4, 'font-size': fs, class: 'kh__m-label', 'text-anchor': 'middle' });
  t.textContent = `${C.fmt(m.width)} cm`;
  g.push(t);
  svg.replaceChildren(...g);
  const rows = [...dims.map(([tag, name, v]) => [compact ? tag : null, name, v]), [null, 'Toplam genişlik', m.width]];
  const key = JSON.stringify(rows);
  const cap = $('[data-kh-measure-cap]');
  if (cap.dataset.khKey !== key) {
    cap.dataset.khKey = key;
    cap.replaceChildren(
      el(
        'dl',
        { class: 'kh__measure-list' },
        rows.map(([tag, name, v]) =>
          el('div', {}, [el('dt', {}, [tag ? el('span', { class: 'kh__measure-tag', text: tag }) : null, name]), el('dd', { text: `${C.fmt(v)} cm` })])
        )
      )
    );
  }
}
new ResizeObserver(() => state.step === 'isik' && drawMeasure()).observe($('[data-kh-measure]'));

// ---------- WhatsApp ve form ----------

function writeLinks() {
  const sum = C.summarize(state, ui.metrics);
  const link = shareURL({ ...state, step: 'ozet' });
  const msg = [LABELS.waIntro, '', sum.text, '', `Tasarım linki: ${link}`].join('\n');
  const href = `https://wa.me/${config.whatsapp}?text=${encodeURIComponent(msg)}`;
  for (const a of $$('[data-kh-wa]')) if (a.href !== href) a.href = href;
  const d = $('[data-kh-f-design]');
  if (d) {
    d.value = sum.text;
    $('[data-kh-f-link]').value = link;
    const u = new URL(link);
    $('[data-kh-f-return]').value = `${u.pathname}${u.search}`;
  }
}

// ---------- Görünüm ----------

function render({ focus = false } = {}) {
  const step = state.step;
  const summary = step === 'ozet';
  root.dataset.step = step;
  renderTrail();
  renderStep(focus && !summary);
  $('[data-kh-measure]').hidden = step !== 'isik';
  for (const sel of ['[data-kh-picks]', '[data-kh-price]', '[data-kh-info]', '[data-kh-sticky]']) $(sel).hidden = !summary;
  const trust = $('[data-kh-trust]');
  trust.hidden = !summary || !trust.childElementCount;
  if (summary) {
    renderPicks();
    renderSpecs();
    renderPrice();
    // Sağ sütunda (teknik özellikler, güvence) gösterilecek bir şey yoksa sütun kalkar
    const side = $('.kh__sum-side');
    side.hidden = [...side.children].every((c) => c.hidden);
    if (focus) focusHeading();
  }
  $('[data-kh-inspect]').hidden = !summary;
  renderLetters();
  renderSample();
  renderMetrics();
  if (step === 'isik') drawMeasure();
}

// Örnek görünüm notu, gündüz/gece düğmesi (örnekte gizli, sahne gündüz)
function renderSample() {
  $('[data-kh-sample]').hidden = !isSample();
  const dn = $('[data-kh-daynight]');
  dn.hidden = !lit() || isSample();
  for (const b of dn.querySelectorAll('[data-kh-view]')) b.setAttribute('aria-pressed', String((b.dataset.khView === 'night') === night()));
  stage.classList.toggle('is-lit', night());
}

function renderLetters() {
  const box = $('[data-kh-letters]');
  box.hidden = ui.mode !== 'letter';
  if (ui.mode !== 'letter') return;
  const seen = [...new Set(chars(displayText()).filter((c) => !/\s/.test(c)))];
  box.replaceChildren(
    el('button', { type: 'button', class: 'kh__letter kh__letter--back', 'data-kh-text-mode': '' }, LABELS.backToText),
    ...seen.map((c) => el('button', { type: 'button', class: 'kh__letter', 'data-kh-letter': c, 'aria-pressed': String(c === ui.letter) }, c))
  );
}

// ---------- 3D ----------

const stage = $('[data-kh-stage]');
const status = $('[data-kh-status]');
let scene = null;
let geoTimer = 0;
let geoPending = false;
let lastLook = '';
let lastNight = null;
let lastSample = null;

function hasWebGL() {
  try {
    const c = document.createElement('canvas');
    return !!(c.getContext('webgl2') || c.getContext('webgl'));
  } catch (e) {
    return false;
  }
}

function geometryParams() {
  const st = C.previewState(state);
  const letter = ui.mode === 'letter' && ui.letter;
  return { mode: letter ? 'letter' : 'text', text: letter ? ui.letter : displayText(), font: st.f, cm: st.cm, depth: C.depthOf(state) };
}

async function pushGeometry() {
  if (!scene) return;
  geoPending = true;
  try {
    await scene.setGeometry(geometryParams());
  } catch (e) {
    console.warn('[kutu-harf]', e);
  }
  geoPending = false;
}

// geometry: yazı/yükseklik gibi alanlar değişti (yazarken kısa gecikmeyle)
function syncScene(debounced = false) {
  clearTimeout(geoTimer);
  updateMetrics();
  if (!scene) return;
  // Örnek ↔ kendi yazısı geçişi beklemeden çizilir
  const sample = isSample();
  if (sample !== lastSample) debounced = false;
  lastSample = sample;
  if (debounced) {
    geoPending = true;
    geoTimer = setTimeout(pushGeometry, 200);
  } else pushGeometry();
  const look = sample ? C.SAMPLE_LOOK : C.resolveLook(state);
  const k = JSON.stringify(look);
  if (k !== lastLook) {
    lastLook = k;
    scene.setLook(look);
  }
  if (night() !== lastNight) {
    scene.setLight(night(), lastNight === null);
    lastNight = night();
  }
}

async function loadScene() {
  if (!hasWebGL()) {
    status.textContent = LABELS.noWebgl;
    stage.classList.add('is-failed');
    root.classList.add('kh--no3d');
    return;
  }
  try {
    const [THREE, mod] = await Promise.all([import(config.three), import(config.scene)]);
    scene = await mod.createScene($('[data-kh-canvas]'), THREE, { fontUrls: config.fonts, mobile: mqMobile.matches, reducedMotion, debug });
    syncScene();
    await pushGeometry();
    stage.classList.add('is-ready');
    observeVisibility();
    if (debug) window.khScene = scene;
    Shots.pump();
  } catch (e) {
    console.warn('[kutu-harf]', e);
    status.textContent = LABELS.loadError;
    stage.classList.add('is-failed');
    root.classList.add('kh--no3d');
  }
}

function observeVisibility() {
  let visible = true;
  const sync = () => scene && scene.setActive(visible && !document.hidden);
  new IntersectionObserver((entries) => {
    visible = entries[entries.length - 1].isIntersecting;
    sync();
  }).observe(stage);
  document.addEventListener('visibilitychange', sync);
}

// ---------- Olaylar ----------

const coerce = (key, v) => (key === 'cm' ? parseInt(v, 10) : v);

root.addEventListener('click', (e) => {
  const t = e.target;
  const goto = t.closest('[data-kh-goto]');
  if (goto) {
    ui.trailOpen = false;
    return go(goto.dataset.khGoto);
  }
  if (t.closest('[data-kh-back]')) {
    if (history.state && history.state.kh > 1) return history.back();
    const list = steps();
    let i = list.indexOf(state.step) - 1;
    while (i > 0 && autoStep(list[i])) i--;
    return go(list[Math.max(0, i)]);
  }
  if (t.closest('[data-kh-trail-toggle]')) {
    ui.trailOpen = !ui.trailOpen;
    return renderTrail();
  }
  if (t.closest('[data-kh-start]')) return state.t.trim() && next();
  if (t.closest('[data-kh-next]')) return next();
  if (t.closest('[data-kh-restart]')) {
    state = { ...C.DEFAULTS, t: state.t, cm: state.cm };
    ui.fontSeen = false;
    return go('yazi');
  }
  if (t.closest('[data-kh-view]')) {
    update({ on: t.closest('[data-kh-view]').dataset.khView === 'night' });
    return;
  }
  if (t.closest('[data-kh-inspect]')) {
    ui.mode = 'letter';
    ui.letter = chars(displayText()).find((c) => !/\s/.test(c)) || null;
    renderLetters();
    pushGeometry();
    return $('[data-kh-letters] [aria-pressed="true"]')?.focus();
  }
  if (t.closest('[data-kh-text-mode]')) {
    ui.mode = 'text';
    renderLetters();
    return pushGeometry();
  }
  const letter = t.closest('[data-kh-letter]');
  if (letter) {
    ui.letter = letter.dataset.khLetter;
    renderLetters();
    pushGeometry();
    return $(`[data-kh-letter="${CSS.escape(ui.letter)}"]`)?.focus();
  }
  if (t.closest('[data-kh-reset]')) return scene && scene.resetView();

  const b = t.closest('button[data-set]');
  if (!b || b.disabled) return;
  const key = b.dataset.set;
  const value = coerce(key, b.dataset.value);
  // Sihirbaz kartları seçip ilerler; adım 1, renk adımı ve özet yalnızca günceller
  const inWizardCard = b.classList.contains('kh__card') && state.step !== 'ozet';
  if (inWizardCard && !STAY.has(key)) return choose(key, value);
  update({ [key]: value }, { pinned: state.step === 'ozet' ? key : null, geometry: key === 'cm' });
  if (state.step === 'renk') $('[data-kh-next]').disabled = !C.stepDone('renk', state);
});

root.addEventListener('change', (e) => {
  const s = e.target.closest('select[data-set]');
  if (!s) return;
  update({ [s.dataset.set]: coerce(s.dataset.set, s.value) }, { pinned: s.dataset.set, geometry: ['cm', 'f'].includes(s.dataset.set) });
});

root.addEventListener('input', (e) => {
  if (e.target.matches('[data-kh-text], [data-kh-sum-text]')) {
    state = { ...state, t: cleanText(e.target.value) };
    if (state.step === 'yazi') renderTextStep();
    renderSample();
    renderMetrics();
    syncScene(true);
    queueURL();
  }
});

$('[data-kh-text]').addEventListener('keydown', (e) => {
  if (e.key === 'Enter' && state.t.trim()) next();
});

$('[data-kh-download]').addEventListener('click', async () => {
  if (!scene) return;
  const blob = await scene.snapshot();
  if (!blob) return void (status.textContent = LABELS.downloadFail);
  const a = el('a', { href: URL.createObjectURL(blob), download: 'kutu-harf-tasarim.png' });
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
});

const FIELD_ERR = {
  valueMissing: (name) => `${name} gerekli.`,
  typeMismatch: () => 'E-posta adresi ad@alanadi.com biçiminde olmalı.',
};
function fieldError(input) {
  const name = root.querySelector(`label[for="${input.id}"]`)?.firstChild?.textContent.trim() || 'Bu alan';
  if (input.validity.valueMissing) return FIELD_ERR.valueMissing(name);
  if (input.validity.typeMismatch) return FIELD_ERR.typeMismatch();
  return '';
}
function showFieldError(input) {
  const msg = fieldError(input);
  let box = document.getElementById(`${input.id}-err`);
  if (!msg) {
    if (box) box.remove();
    input.removeAttribute('aria-invalid');
    return true;
  }
  if (!box) {
    box = el('p', { class: 'kh__f-err', id: `${input.id}-err` });
    input.after(box);
    input.setAttribute('aria-describedby', box.id);
  }
  box.textContent = msg;
  input.setAttribute('aria-invalid', 'true');
  return false;
}
const form = $('[data-kh-form]');
if (form) {
  form.noValidate = true;
  for (const input of form.querySelectorAll('input[required]')) {
    input.addEventListener('blur', () => input.value !== '' && showFieldError(input));
    input.addEventListener('input', () => input.hasAttribute('aria-invalid') && showFieldError(input));
  }
  form.addEventListener('submit', (e) => {
    const bad = [...form.querySelectorAll('input[required]')].filter((i) => !showFieldError(i));
    if (bad.length) {
      e.preventDefault();
      bad[0].focus();
    }
  });
}

$('[data-kh-form]')?.addEventListener('submit', (e) => {
  if (e.defaultPrevented) return;
  writeLinks();
  try {
    sessionStorage.setItem('kh-design', C.toParams({ ...state, step: 'ozet' }).toString());
  } catch (e) {
    /* gizli pencere */
  }
});
for (const a of $$('[data-kh-wa]')) a.addEventListener('click', writeLinks);

// ---------- Başlat ----------

(function injectFontFaces() {
  const css = FONTS.map((f) => `@font-face{font-family:'${f.family}';src:url('${config.fontFaces[f.id]}');font-display:swap;}`).join('');
  document.head.append(el('style', { text: css }));
})();

// Form gönderildiyse özet ekranı ve teşekkür mesajı; tasarım adresten, yoksa oturumdan geri yüklenir
if ($('[data-kh-posted]')) {
  let saved = null;
  try {
    saved = sessionStorage.getItem('kh-design');
  } catch (e) {
    /* gizli pencere */
  }
  if (!new URLSearchParams(location.search).has('p') && saved) state = C.fromParams(new URLSearchParams(saved), cleanText);
  state = { ...C.completeState(state), step: 'ozet' };
}

try {
  history.replaceState({ kh: (history.state && history.state.kh) || 1 }, '', shareURL(state, true));
} catch (e) {
  /* yok say */
}
render();
syncScene();
if ($('[data-kh-posted]')) $('[data-kh-posted]').focus();

const start = () => ('requestIdleCallback' in window ? requestIdleCallback(loadScene, { timeout: 1500 }) : setTimeout(loadScene, 200));
if (document.readyState === 'complete') start();
else window.addEventListener('load', start, { once: true });
